import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SuccessAlert from "./../child/Alert/SuccessAlert";
import DengerAlert from "./../child/Alert/DengerAlert";
import Loader from "./../child/Loder";
import { getDiscountDetail } from "../../services/discountService";
import moment from "moment";

const getTotalUseCount = (item) => {
  const value =
    item?.totalUseCount ??
    item?.totalUsed ??
    item?.total_used ??
    item?.total_use_count ??
    0;
  const num = Number(value);
  return Number.isFinite(num) ? num : 0;
};

const ViewDiscountPageNew = () => {
  const [itemData, setItemData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await getDiscountDetail(id);
        const payload = res?.data || {};
        const data =
          payload.result || payload.data || payload.discount || payload;
        setItemData(data);
      } catch (err) {
        setErrorMessage("Failed to fetch discount detail.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  if (loading) return <Loader />;
  return (
    <div className="row gy-4">
      {successMessage && (
        <SuccessAlert
          message={successMessage}
          onClose={() => setSuccessMessage("")}
        />
      )}
      {errorMessage && (
        <DengerAlert
          message={errorMessage}
          onClose={() => setErrorMessage("")}
        />
      )}
      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="row">
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold">Code</label>
                <div>{itemData?.code || "N/A"}</div>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">Discount</label>
                <p>{itemData?.discount ?? "N/A"}</p>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">Total Used</label>
                <p>{getTotalUseCount(itemData)}</p>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">Start Date</label>
                <p>
                  {itemData?.startDate
                    ? moment(itemData.startDate).format("DD-MM-YYYY")
                    : "N/A"}
                </p>
              </div>
              <div className="col-md-2 mb-3">
                <label className="form-label fw-bold mt-2">End Date</label>
                <p>
                  {itemData?.endDate
                    ? moment(itemData.endDate).format("DD-MM-YYYY")
                    : "N/A"}
                </p>
              </div>
              <div className="col-md-2 mb-3">
                {itemData?.type === "host" && (
                  <>
                    <label className="form-label fw-bold mt-2">Host By</label>
                    <p>{itemData?.userId?.fullName || "N/A"}</p>
                  </>
                )}
              </div>
            </div>

            <div className="col-md-12">
              <label className="form-label fw-bold mt-2">Description</label>
              <p>{itemData?.description || "N/A"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewDiscountPageNew;
